<template>
  <VRegisterApp :nav="!workbench" name="payment" :workbench="workbench" :checkout="checkout" @mounted="handleMounted" @next="handleNext">
    <template #header v-if="!checkout">
      <div style="margin: 0 0 0 0" v-if="approvalAll">
        <el-alert type="warning" title="参会人员正在审核，请等待" :show-icon="true" :closable="false" effect="dark"></el-alert>
      </div>
      <template v-else>
        <div class="header" v-if="template === '2'">
          <div class="left-header">
            <el-radio-group v-model="status" @change="handleStatus">
              <el-radio label="0" border>{{ $t(`registration.payment.status-all`) }}</el-radio>
              <el-radio label="1" border>{{ $t(`registration.payment.status-approval`) }}</el-radio>
              <el-radio label="2" border>{{ $t(`registration.payment.status-pending`) }}</el-radio>
              <el-radio label="3" border>{{ $t(`registration.payment.status-paid`) }}</el-radio>
            </el-radio-group>
          </div>
          <div class="right-header">
            <el-button v-if="false" @click="handleInovice">
              <span>{{ $t(`registration.payment.fapiao`) }}</span>
            </el-button>
          </div>
        </div>

        <div class="header" v-if="template === '1'">
          <div class="left-header">
            <el-radio-group v-model="status" @change="handleStatus">
              <el-radio label="0" border>{{ $t(`registration.payment.status-all`) }}</el-radio>
              <el-radio label="1" border>{{ $t(`registration.payment.status-approval`) }}</el-radio>
              <el-radio label="2" border>{{ $t(`registration.payment.status-pending`) }}</el-radio>
              <el-radio label="3" border>{{ $t(`registration.payment.status-paid`) }}</el-radio>
            </el-radio-group>
          </div>
          <div class="right-header">
            <el-button v-if="false" @click="handleInovice">
              <span>{{ $t(`registration.payment.fapiao`) }}</span>
            </el-button>
          </div>
        </div>
      </template>
    </template>

    <div class="table" v-loading="loading">
      <vxe-table
        ref="tableRefs"
        :data="tableData"
        :border="'inner'"
        align="center"
        :checkbox-config="{
          checkMethod: ({ row }) => {
            if (row.Transfer === true) {
              return false
            }
            return row.Status === 'ready' && row.OrderStatus != 'approval' && !(row.AuditStatus == null || (row.AuditStatus[0] > 0 && row.AuditStatus[0] != row.AuditStatus[2]))
          },
          visibleMethod({ row }) {
            return true
            //return row.Status === 'ready' && row.OrderStatus != 'approval' && !(row.AuditStatus == null || (row.AuditStatus[0] > 0 && row.AuditStatus[0] != row.AuditStatus[2]))
          },
        }"
      >
        <vxe-column type="checkbox" width="50" fixed="left" align="center"></vxe-column>
        <!-- <vxe-column field="OrderID" :title="$t(`registration.payment.table-orderid`)" min-width="150"></vxe-column> -->
        <vxe-column field="TicketName" :title="$t(`registration.payment.table-code`)" :min-width="150">
          <template #default="{ row }">
            {{ row.TicketName.split('|')[$language] || row.TicketName }}
          </template>
        </vxe-column>
        <vxe-column field="TicketPrice" :title="$t(`registration.payment.table-price`)" width="80"></vxe-column>
        <vxe-column field="Number" :title="$t(`registration.payment.table-number`)" width="80"></vxe-column>
        <vxe-column field="Total" :title="$t(`registration.payment.table-money`)" width="80"></vxe-column>
        <vxe-column field="Status" :title="$t(`registration.payment.table-status`)" width="120">
          <template #default="{ row }">
            <!--AuditStatus-->
            <template v-if="(row.Status || '').toLocaleLowerCase() === 'ready'">
              <template v-if="row.AuditStatus == null || (row.AuditStatus[0] > 0 && row.AuditStatus[0] != row.AuditStatus[2])">{{ $t(`registration.payment.status-approval`) }}</template>
              <template v-else-if="row.Transfer === true">{{ ['银行转帐', 'Transfer'][$language] }}</template>
              <template v-else-if="(row.OrderStatus || '').toLocaleLowerCase() === 'approval'">{{ $t(`registration.payment.status-approval`) }}</template>

              <template v-else>{{ $t(`registration.payment.status-pending`) }}</template>
            </template>
            <template v-else>{{ $t(`registration.payment.status-paid`) }}</template>
          </template>
        </vxe-column>
        <vxe-column :title="$t(`registration.payment.table-operation`)" width="120" align="center">
          <template #default="{ row }">
            <template v-if="(row.Status || '').toLocaleLowerCase() === 'ready'">
              <template v-if="row.AuditStatus == null || (row.AuditStatus[0] > 0 && row.AuditStatus[0] != row.AuditStatus[2])">
                <el-button link type="primary" @click="handleCancelOrder(row)">{{ $t(`registration.payment.cancel`) }}</el-button>
              </template>

              <template v-else-if="(row.OrderStatus || '').toLocaleLowerCase() === 'approval'">
                <el-button link type="primary" @click="handleCancelOrder(row)">{{ $t(`registration.payment.cancel`) }}</el-button>
              </template>
              <template v-else>
                <el-button v-if="workbench" link type="primary" @click="handlePay([row.ID])">{{ $t(`registration.payment.pay-now`) }}</el-button>
                <el-button link type="primary" @click="handleCancelOrder(row)">{{ $t(`registration.payment.cancel`) }}</el-button>
              </template>
            </template>
            <template v-else>
              <el-button v-if="$event.Config.Invoice" link type="primary" @click="handleInovice(row)">{{ $t(row.Inovice ? `registration.payment.fapiao2` : `registration.payment.fapiao`) }}</el-button>
            </template>
          </template>
        </vxe-column>
      </vxe-table>
    </div>

    <VCoupon ref="vCouponRefs" @close="({ rows }) => vPayRefs.show(rows)" />
    <VPay ref="vPayRefs" @paid="handlePaid" />
    <VInovice ref="vInoviceRefs" @update="fetchData" />

    <div v-if="workbench" style="display: flex; justify-content: center; padding: 24px">
      <el-button v-if="checkout" class="next" type="primary" @click="$router.push({ name: 'checkout-index' })">{{ $t('registration.btn.prev') }}</el-button>

      <el-button class="next" type="primary" @click="handleNext">{{ $t('registration.btn.next') }}</el-button>
    </div>
  </VRegisterApp>
</template>

<script setup>
  import { useAppStore } from '@/store/modules/app'
  import VRegisterApp from '../app/index.vue'
  import { getPageConfig, getSteps } from '@/api/config'
  import { getOrderList, cancelOrder, payment, getInformation } from '@/api/registration'
  import { checkPaymentStatus } from '@/api/payment'

  import { onMounted, ref, inject, computed, provide, nextTick } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
  import VCoupon from './coupon.vue'
  import VPay from './pay.vue'
  import VInovice from './inovice.vue'
  import { useRouter, useRoute } from 'vue-router'

  import { useI18n } from 'vue-i18n'
  import { storeToRefs } from 'pinia'
  const { t, te } = useI18n()

  const router = useRouter()
  const route = useRoute()
  const props = defineProps({
    workbench: {
      type: Boolean,
      default: false,
    },

    checkout: {
      type: Boolean,
      default: false,
    },
  })

  const { template } = storeToRefs(useAppStore())
  const form = ref({})
  const steps = ref([])
  const pageConfig = ref({})
  const loading = ref(true)
  const show = ref(false)
  const status = ref('0')

  const vCouponRefs = ref(null)
  const vPayRefs = ref(null)
  const vInoviceRefs = ref(null)

  const tableData = ref([])
  const orderList = ref([])
  const tableRefs = ref(null)

  const $steps = inject('$steps')
  const $event = inject('$event')

  const $language = inject('$language')

  const current = computed(() => {
    for (var g of $steps.value) {
      if (g.Name == 'payment') {
        return g
      }
    }
    return null
  })

  const approvalTips = computed(() => {
    //

    for (var g of orderList.value) {
      if (g.Status.toLocaleLowerCase() != 'ready') {
        //如果存在已支付的
        return false
      }
      if (g.AuditStatus[0] != g.AuditStatus[2]) {
        return true
      }
    }
    return false
  })

  const approvalAll = computed(() => {
    //
    let num = 0
    for (var g of orderList.value) {
      if (g.AuditStatus[0] != g.AuditStatus[2]) {
        num += 1
      }
    }
    return num > 0 && num === orderList.value.length
  })

  onMounted(async () => {
    //
    loading.value = true
    if (route.query.out_order_no) {
      try {
        const { data: s } = await checkPaymentStatus({ out_trade_no: route.query.out_order_no })
        if (s.status === 1) {
          
      loading.value = false
          if (props.checkout) {
            router.push({ name: 'checkout-confirmation' })
            return
          }
          //
          let to = 'confirmation'
          const { data: z } = await getInformation()
          loading.value = false
          console.log(z)
          let steps = z.steps || []
          for (var i = 0, len = steps.length; i < len; i++) {
            if ((steps[i] === 'payment') & (i < len - 1)) {
              to = steps[i + 1]
            }
          }
          router.push({ name: to }) //不选，则自动
          //router.push({ name: 'confirmation' }) //不选，则自动
          return
        }
      } catch {}
      loading.value = false
    }

    const { data: x } = await getSteps()
    steps.value = x.filter((x) => x.Name !== 'login')
    console.log('steps', steps.value)
    const { data } = await getPageConfig('ticket')
    pageConfig.value = data
    //
    await fetchData()
    loading.value = false
    status.value = '0'
    //

    if (props.checkout === true) {
      handleStatus()
    }

    nextTick(() => {
      //const loadIngInstance=ElLoading.service({fullscreen:true})
      //
      let data = []
      for (var g of orderList.value) {
        if (g.Transfer === true) {
          continue
        }
        if (g.Status === 'ready' && (g.OrderStatus || '').toLocaleLowerCase() !== 'approval') {
          if (!(g.AuditStatus == null || (g.AuditStatus[0] > 0 && g.AuditStatus[0] != g.AuditStatus[2]))) {
            data.push(g)
          }
        }
      }
      if (props.checkout) {
        tableRefs.value.setCheckboxRow(data, true)
        handleNext()
        return
      }
      if (data.length == 1) {
        if (!props.workbench) {
          tableRefs.value.setCheckboxRow(data, true)
          handleNext()
        }
      } else {
        if (!props.workbench) {
          tableRefs.value.setCheckboxRow(data, true)
        }
      }
    })
  })

  const fetchData = async () => {
    const { data: o } = await getOrderList()
    orderList.value = o
    tableData.value = o
  }

  const handleStatus = (val) => {
    if (val == '0') {
      tableData.value = orderList.value
    } else if (val == '1') {
      tableData.value = orderList.value.filter((x) => x.Status.toLocaleLowerCase() == 'ready' && (x.OrderStatus.toLocaleLowerCase() == 'approval' || x.AuditStatus[0] != x.AuditStatus[2]))
    } else if (val == '2') {
      tableData.value = orderList.value.filter((x) => x.Status.toLocaleLowerCase() == 'ready' && !(x.OrderStatus.toLocaleLowerCase() == 'approval' || x.AuditStatus[0] != x.AuditStatus[2]))
    } else if (val == '3') {
      tableData.value = orderList.value.filter((x) => x.Status.toLocaleLowerCase() != 'ready')
    }
  }

  const handleCancelOrder = (row) => {
    ElMessageBox.confirm(t(`registration.payment.cancel-confirm`), '', {
      type: 'warning',
    })
      .then(async () => {
        const loadingInstance = ElLoading.service({ fullscreen: true })
        try {
          const { ret } = await cancelOrder(row.ID)
          ElMessage({ message: t(`registration.payment.cancel-ok`), type: 'success' })
          await fetchData()
        } catch (e) {}
        loadingInstance.close()
      })
      .catch(() => {})
  }

  //
  //开始支付
  //
  const handlePay = (rows) => {
    if (rows == null || rows.length == 0) {
      ElMessage({ message: t(`registration.payment.pay-no-record`), type: 'error' })
      return
    }
    //
    if (!$event.Config.Discount) {
      vPayRefs.value.show(rows)
      return
    }
    vCouponRefs.value.show(rows)
  }

  const handleInovice = (row) => {
    vInoviceRefs.value.show(row)
  }
  const handlePaid = async () => {
    console.log('handlePaid')
    tableRefs.value.clearCheckboxRow()
    await fetchData()
    await handleNext()
  }

  const handleNext = async () => {
    if (approvalAll.value) {
      ElMessage({ message: '参会人正在审核，请稍候', type: 'error' })
      return
    }
    let rows = tableRefs.value.getCheckboxRecords().map((x) => x.ID)
    if (rows == null || rows.length == 0) {
      let paid = orderList.value.filter((x) => x.Status != 'ready' || x.Transfer === true)
      if (paid.length == 0) {
        ElMessage({ message: t(`registration.payment.pay-no-record`), type: 'error' })
        return
      }
      if (props.checkout) {
        router.push({ name: 'checkout-confirmation' })
        return
      }
      if (!props.workbench) {
        let to = 'confirmation'
        const { data: z } = await getInformation()
        console.log(z)
        let steps = z.steps || []
        for (var i = 0, len = steps.length; i < len; i++) {
          if ((steps[i] === 'payment') & (i < len - 1)) {
            to = steps[i + 1]
          }
        }
        console.log('to', to)
        // return
        router.push({ name: to }) //不选，则自动
      } else {
        ElMessage({ message: t(`registration.payment.pay-no-record`), type: 'error' })
      }
      return
    } else {
      if (!$event.Config.Discount) {
        vPayRefs.value.show(rows)
        return
      }
      vCouponRefs.value.show(rows)
      return
    }
  }
  //
  const handleMounted = (val) => {
    pageConfig.value = val.pageConfig
  }

  const hasPay = computed(() => {
    return orderList.value.filter((x) => x.Status.toLocaleLowerCase() != 'ready').length > 0
    //(row.Status || '').toLocaleLowerCase() === 'ready'
  })

  provide('$config', pageConfig.value)
  provide('$order', orderList)
</script>

<style lang="scss" scoped>
  .register-container {
    :deep() {
      .register-form {
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      &.payment {
        background: #f8f9fa;
        border-radius: 4px;

        border-color: var(--el-color-primary);
        color: var(--el-color-primary);
        .el-icon {
          font-size: 16px;
          margin-right: 3px;
          svg {
            :deep() {
              path {
                stroke: var(--el-color-primary);
              }
            }
          }
        }
        span {
          margin-left: 0px;
        }
      }
    }
  }
  .el-radio-group {
    :deep() {
      .el-radio__input {
        display: none;
      }
      .el-radio {
        margin-right: 12px;
        background: #f8f9fa;
        border: 1px solid #dadfe3;
        border-radius: 4px;
        color: #363f5e;
        &.is-checked {
          border-color: var(--el-color-primary);
          color: var(--el-color-primary);
        }
      }
    }
  }
  .table {
    margin: 0 0;
  }

  .vxe-table {
    :deep() {
      .vxe-table--header-wrapper {
        background-color: #f1f4f9;
        th.el-table__cell {
          height: 56px;
        }
      }
      .vxe-table--body-wrapper {
        .vxe-body--column {
          background-image: linear-gradient(#f0f0f0, #f0f0f0);
        }
      }
      .vxe-table--border-line {
        border: solid 1px #f0f0f0;
      }
    }
    .el-button + .el-button {
      margin-left: 3px;
    }
  }
  .el-alert {
    font-weight: normal;
  }
</style>
